import { render, staticRenderFns } from "./ColorBarPlot.vue?vue&type=template&id=2f6ef261&"
import script from "./ColorBarPlot.vue?vue&type=script&lang=js&"
export * from "./ColorBarPlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f6ef261')) {
      api.createRecord('2f6ef261', component.options)
    } else {
      api.reload('2f6ef261', component.options)
    }
    module.hot.accept("./ColorBarPlot.vue?vue&type=template&id=2f6ef261&", function () {
      api.rerender('2f6ef261', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ColorBarPlot.vue"
export default component.exports